export const API_BASE_URL = process.env.API_BASE_URL || 'https://excessive-christel-malphite-node-1c99dc92.koyeb.app/api';